import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";
import { NEWS } from "@/data/news";

/**
 * Newsroom / Formation Milestones — modeled after Blackstone &
 * Carlyle press / newsroom landing modules. For a platform in
 * formation we frame items as documented milestones.
 */


const Newsroom = () => {
  return (
    <section
      id="newsroom"
      data-testid={LANDING.newsroom}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-end mb-16">
          <div className="lg:col-span-8">
            <SectionHeading
              index="17"
              label="Newsroom · Formation Milestones"
              title={
                <>
                  Documented{" "}
                  <span className="italic text-[var(--kr-gold)]">
                    milestones
                  </span>{" "}
                  on the path to launch.
                </>
              }
            />
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link
              to="/news"
              data-testid={LANDING.newsroomMedia}
              className="kr-link font-mono-label text-[11px]"
            >
              Full Newsroom →
            </Link>
          </div>
        </div>

        <ul className="border-t border-[var(--kr-line)]">
          {NEWS.map((e, i) => (
            <li
              key={e.slug}
              data-testid={`${LANDING.newsroomItemPrefix}${i}`}
              className="border-b border-[var(--kr-line)]"
            >
              <Link
                to={`/news/${e.slug}`}
                data-testid={`${LANDING.newsroomItemLinkPrefix}${i}`}
                className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-baseline py-9 group hover:bg-[rgba(201,169,110,0.025)] transition-colors duration-500"
              >
                <div className="lg:col-span-2 font-mono-label text-[10px] text-[var(--kr-gold)]">
                  {e.date}
                </div>
                <div className="lg:col-span-2 font-mono-label text-[10px] text-[var(--kr-text-muted)]">
                  {e.kind}
                </div>
                <div className="lg:col-span-7 font-serif-display text-[var(--kr-text)] text-[1.35rem] lg:text-[1.5rem] leading-[1.3] group-hover:text-[var(--kr-gold)] transition-colors duration-500">
                  {e.headline}
                </div>
                <div
                  aria-hidden
                  className="lg:col-span-1 lg:text-right font-mono-label text-[11px] text-[var(--kr-text-muted)] group-hover:text-[var(--kr-gold)] transition-colors duration-500"
                >
                  →
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Newsroom;
